export function ShowAnimeCard(anime, i) {

    return (
        <a rel="noreferrer" target="_blank" href={"https://www.themoviedb.org/movie/"+anime.id} class="relative w-[200px] mb-5">
            <img src={"https://image.tmdb.org/t/p/w500"+anime.poster_path} alt={anime.title} width="200px"/>
            <h1 class="text-2xl font-bold font-montserrat">{anime.title}</h1>
            <h2 class="absolute top-0 left-0 m-1 text-2xl font-bold text-white">#{i+1}</h2>
        </a>
    )
}